import { EventChannel, eventChannel } from 'redux-saga';
import { navigate } from '../../felles/navigationService';
import { call, fork, put, select, take } from 'redux-saga/effects';
import Utils from '../../felles/Utils';

import { postErrorToSupport } from '../../felles/APICalls_SPRING';
import { fetchTransById, getHelpTransVitec, getWSDataFromAxios, postTransFormDataAxios } from '../../felles/APICalls_VSE';
import ErrorMSG from '../../models/payload/ErrorMSG';
import HeirloomFormData from '../../models/payload/HeirloomFormData';
import SimpleMSG from '../../models/SimpleMSG';
import * as actions from '../actions';
import * as selectors from '../selectors';

let socket: WebSocket;
let channel: EventChannel<any>;

// Wait for WebSocket connection to be ready
const waitForOpenConnection = (socket: WebSocket): Promise<void> => {
  return new Promise((resolve, reject) => {
    const maxNumberOfAttempts = 10;
    const intervalTime = 200; // ms

    let currentAttempt = 0;
    const interval = setInterval(() => {
      if (currentAttempt > maxNumberOfAttempts - 1) {
        clearInterval(interval);
        reject(new Error('Maximum number of attempts exceeded'));
      } else if (socket.readyState === socket.OPEN) {
        clearInterval(interval);
        resolve();
      }
      currentAttempt++;
    }, intervalTime);
  });
};

// Send message with connection waiting
// Supports pipe-delimited format: "BUTTON=value|field1=value1|field2=value2|"
export const sendMessage = async (socket: WebSocket, msg: string): Promise<void> => {
  if (socket.readyState !== socket.OPEN) {
    try {
      await waitForOpenConnection(socket);
      socket.send(msg);
    } catch (err) {
      console.error('Failed to send message:', err);
    }
  } else {
    socket.send(msg);
  }
};

export function* setInputArrayStates(response: any, formDataforBugRepporting: HeirloomFormData = new HeirloomFormData()) {
  const formData: string = formDataforBugRepporting?.formData ? formDataforBugRepporting.formData : 'No form data provided.';
  const transId: string = formDataforBugRepporting?.transId ? formDataforBugRepporting?.transId + ' ' : 'No transId.';
  const transGetInitTimestamp: string = yield select(selectors.transGetInitTimestamp);

  try {
    if (response.data?.body?.textContent?.includes('COBOL runtime error')) {
      const errorMSG = new ErrorMSG(
        window.location.toString(),
        'NO EMAIL PROVIDED',
        transId + 'ERROR - ' + Utils.T_cn + ' | ' + Utils.T_company
        + ' | Build: F' + Utils.VERSION + ' | A' + Utils.T_apiVersion
        + ' | S: ' + transGetInitTimestamp + ' | E: ' + Utils.getTimeStamp(),
        response.data.body.textContent,
        formData
      );
      yield sendErrorToSupport(errorMSG);
      return;
    }

    // Clean up
    yield put(actions.resetKeyInputFieldBinding());

    // 25 lines
    const inputArrayLineState: any[] = [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []];

    //
    // Get the field to attach focus
    // let fieldToAttachFocus = undefined
    // Get all script elements from the response
    const scriptElements = response.data.body.getElementsByTagName('script');

    // Iterate through the script elements and log their content
    // JDK 17
    for (let i = 0; i < scriptElements.length; i++) {
      if (scriptElements[i].innerText?.toLowerCase()?.includes('focusoneditablefield')) {
        const fieldToAttachFocus = scriptElements[i].innerText?.split("('")[1].split("')")[0] || '';
        yield put(actions.setFieldSelectEnabled(true));
        yield put(actions.setFieldToAttachFocus(fieldToAttachFocus));
        yield put(actions.setDefaultFieldFocus(fieldToAttachFocus));
      }
    }
    // JDK 1.8
    if (response.data.body.getAttribute('onload')?.toLowerCase()?.includes('focusoneditablefield')) {
      const fieldToAttachFocus = response.data.body.getAttribute('onload')?.split("('")[1].split("')")[0] || '';
      yield put(actions.setFieldSelectEnabled(true));
      yield put(actions.setFieldToAttachFocus(fieldToAttachFocus));
      yield put(actions.setDefaultFieldFocus(fieldToAttachFocus));
    }
    //
    const form = response.data.body.getElementsByTagName('form')[0] as HTMLFormElement;
    const sdf: HTMLCollection = (form as any).getElementsByTagName('input') as HTMLCollection;
    const result = [].slice.call(sdf);
    //
    const initState: any = {};
    result.forEach((element) => {
      if ((element as HTMLFormElement).getAttribute('class')?.includes('line')) {
        const index = (element as HTMLFormElement).getAttribute('class')?.split('line')[1].split(' ')[0];
        if (index) {
          inputArrayLineState[parseInt(index)].push((element as HTMLFormElement).getAttribute('name'));
        }
      }
      //
      if ((element as HTMLInputElement).value) {
        initState[(element as HTMLInputElement).name] = (element as HTMLInputElement).value;
      }
    });
    //
    const inputArrayLineStateFiltered = inputArrayLineState.filter(function (el) {
      return el.length > 0 ? el : null;
    });
    //
    yield put(actions.updateInputArrayState(result));
    // Populates inputs coords list as [y][x]
    yield put(actions.updateInputArrayLineState(inputArrayLineStateFiltered));
    //
    yield put(actions.setInputState(initState));

    /*
    const errorMSG = new ErrorMSG(window.location.toString(), 'NO EMAIL PROVIDED', transId + 'ERROR - ' + Utils.T_cn + ' | '
      + Utils.T_company + ' | Build: F' + Utils.VERSION + ' | A' + Utils.T_apiVersion + ' | S: ' + transGetInitTimestamp
      + ' | E: ' + Utils.getTimeStamp(), '(error as any)?.message', formData);
       errorMSG.email = Utils.T_email;
      errorMSG.mobile = Utils.T_mobile;
    yield sendErrorToSupport(errorMSG);
    */

  } catch (error) {
    const formData: string = (formDataforBugRepporting as HeirloomFormData)?.formData
      ? (formDataforBugRepporting as HeirloomFormData).formData + ' -----===== ERROR =====-----> ' + (error as any)?.message
      : 'No form data provided.  -----===== ERROR =====-----> ' + (error as any)?.message;
    const transId: string = (formDataforBugRepporting as HeirloomFormData)?.transId ? (formDataforBugRepporting as HeirloomFormData)?.transId + ' ' : 'No transId.';
    const errorMSG = new ErrorMSG(window.location.toString(), 'NO EMAIL PROVIDED', transId + 'ERROR - ' + Utils.T_cn + ' | '
      + Utils.T_company + ' | Build: F' + Utils.VERSION + ' | A' + Utils.T_apiVersion + ' | S: ' + transGetInitTimestamp
      + ' | E: ' + Utils.getTimeStamp(), (error as any)?.message, formData);
    errorMSG.email = Utils.T_email;
    errorMSG.mobile = Utils.T_mobile;
    yield sendErrorToSupport(errorMSG);
  }
}

// todo: initialize UserUpdatePayload
export function* sendErrorToSupport(errorMSG: ErrorMSG) {
  yield put(actions.transFormDataPostFailed(new SimpleMSG('Cobol Runtime', errorMSG.error.toString())));
  //
  try {
    yield put(actions.AutoErrorSendingPostStarted());
    const responseFromPost = yield postErrorToSupport(errorMSG);
    yield put(actions.AutoErrorSendingPostSuccess(responseFromPost.data));
  } catch (error) {
    yield put(actions.AutoErrorSendingPostFailed(error));
  }
}

function getConnection(wsMSG, isNewSocket = false): EventChannel<any> {
  //
  return eventChannel((emitter) => {
    //
    const initConnection = () => {
      const connectionUrl: string = Utils.WEBSOCKET_ADDRESS + '/vitec/terminalwebsocket';
      if (isNewSocket) {
        socket = new WebSocket(connectionUrl);
      } else {
        if (!socket) {
          socket = new WebSocket(connectionUrl);
        }
      }
      // Use sendMessage to handle connection waiting
      if (wsMSG !== '' && !wsMSG.includes('termId=')) {
        sendMessage(socket, wsMSG).catch(err => {
          Utils.error('Failed to send initial message:', err);
        });
      }

      socket.onopen = () => {
        if (wsMSG !== '' && wsMSG.includes('termId=')) {
          socket.send(wsMSG);
        }
      };
      socket.onmessage = (event) => {
        emitter(event.data);
      };
      socket.onclose = () => {
        if (channel) {
          channel.close();
        }
        // setTimeout(initConnection, 4000); //"Reconnect in 4s
        // or
        // setTimeout(() => getConnection(wsMSG,isNewSocket), 2000); //"Reconnect in 4s
      };
    };
    initConnection();
    return () => {
      Utils.log('Socket off');
    };
  });
}

function* wsConnectionWorker(action, isNewSocket) {
  let wsRequest = '';
  switch (true) {
    case typeof action === 'string':
      wsRequest = action;
      break;
    case action.payload?.wsMessage !== '':
      wsRequest = action.payload?.wsMessage;
      break;
    default:
      wsRequest = '';
      break;
  }

  if (wsRequest && wsRequest.includes('termId=')) {
    yield put(actions.setShowOpenModalWindow(false));
  }
  /*const channel: EventChannel<boolean> =*/
  channel = yield call(getConnection, wsRequest, isNewSocket);
  // On Channel ready
  try {
    while (true) {
      const _payload: any = yield take(channel);
      if (!_payload) continue;

      if (!Utils.isAModalCall(_payload)) {
        yield put(actions.setTermID(_payload));
      }
      yield getWsdata(_payload);
    }
  } finally {
    // if task is cancelled or channel ends, ensure socket is closed
    // (channel unsubscribe also closes handlers)
  }
}

export function userLogoutFromTerminalSaga() {
  try {
    if (socket) {
      socket.close();
      Utils.log('Closing WS socket');
    }
  } catch (error) {
    Utils.log('Problem closing websocket -> userLogoutFromTerminalSaga');
  }
}

/*
 * Simple GET method that calls the transaction presentation
 *
 *
 * ░░███╗░░░██████╗████████╗
 * ░████║░░██╔════╝╚══██╔══╝
 * ██╔██║░░╚█████╗░░░░██║░░░
 * ╚═╝██║░░░╚═══██╗░░░██║░░░
 * ███████╗██████╔╝░░░██║░░░
 * ╚══════╝╚═════╝░░░░╚═╝░░░
 *
 */
export function* fecthTransactionById(action: any) {
  const tabId = yield select(selectors.tabId);
  let zTermId: any = undefined;
  yield put(actions.resetHTMLContent());
  navigate(`${Utils.HOMEPAGE_CONTEXT}/vse?transid=${action.payload.code}`);
  try {
    yield put(actions.transGetInit());
    const response = yield fetchTransById(action.payload, tabId);
    if (response && response.data) {
      yield setInputArrayStates(response, new HeirloomFormData());
      const bob = (response.data.head as Document).querySelectorAll('script');
      bob.forEach((e) => {
        if (e.innerHTML.includes('termId')) {
          zTermId = e.innerHTML.split('termId')[1].split('"')[1];
        }
      });

      yield put(actions.transGetSuccess(response.data, zTermId));
      yield put(actions.setIsTransPostInProgress(false));
      yield put(actions.setIsTransGetInProgress(false));
      yield put(actions.menuItemSetTarget(action.payload));
      yield put(actions.menuItemSetSelected([action.payload.rootItem, action.payload.item + action.payload.rootItem]));
      if (zTermId) {
        yield fork(wsConnectionWorker, 'termId=' + zTermId, true);
      }
    }
  } catch (error) {
    yield put(actions.transGetFailed(error));
  }
}

/*
 * POST data, parse the response and search for a termid value that will trigger a websocket call
 *
 * ██████╗░███╗░░██╗██████╗░
 * ╚════██╗████╗░██║██╔══██╗
 * ░░███╔═╝██╔██╗██║██║░░██║
 * ██╔══╝░░██║╚████║██║░░██║
 * ███████╗██║░╚███║██████╔╝
 * ╚══════╝╚═╝░░╚══╝╚═════╝░
 *
 */
export function* postTransFormdata(action: any) {
  const tabId: string = yield select(selectors.tabId);
  try {
    // Important to the next channel event.
    yield fork(wsConnectionWorker, '', false);

    // Initialize the post and loading screen
    yield put(actions.transFormDataPostInit());

    // Call API
    const response = yield postTransFormDataAxios(action.payload, tabId);

    // Await the response
    if (response && response.data) {
      yield fork(setInputArrayStates, response, action.payload);
      yield put(actions.transFormDataPostSuccess(response.data));
      // Creates a new websocket connection ready for the next post
      yield fork(wsConnectionWorker, 'termId=' + action.payload.termId, true);
    }
  } catch (error) {
    yield put(actions.transFormDataPostFailed(new SimpleMSG('Error', (error as any).toString())));
    navigate(`${Utils.HOMEPAGE_CONTEXT}/support`);
  }
}

/*
 *
 *
 */
export function* postToWebSocket(action: any) {
  try {
    yield fork(wsConnectionWorker, action.payload, false);
  } catch (error) {
    Utils.log('Post to ws failed: ', error);
  }
}

/*
 * GET triggered by postTransFormdata Websocket callback
 */
export function* getWsdata(action: any) {
  const tabId = yield select(selectors.tabId);
  // OPEN MODAL WINDOW CALLED
  if (Utils.isAModalCall(action)) {
    try {
      yield put(actions.transOpenModalWindowPostInit());
      yield put(actions.transOpenModalWindowPostSuccess(action));
    } catch (error) {
      yield put(actions.transOpenModalWindowPostFailed(error));
    }
  } else {
    const params: any = Utils.getJsonFromUrl(action.replace('/servlet?', '&'));
    const navFormData = new HeirloomFormData(params.transid, params.transid ? params.scode : '', '');
    try {
      navigate(`${Utils.HOMEPAGE_CONTEXT}${action.replace('/servlet', '/vse')}`);
      const response = yield getWSDataFromAxios(navFormData, tabId);
      if (response && response.data /* && response.body*/) {
        yield fork(setInputArrayStates, response, new HeirloomFormData());
      }
      yield put(actions.transFormDataPostSuccess(response.data));
    } catch (error) {
      yield put(actions.transFormDataPostFailed(new SimpleMSG('Error in getWsdata', (error as any).toString())));
    }
  }
}

/*
 *
 *
 */
export function* fecthHelpTransaction(action: any) {
  yield put(actions.transHelpGetInit());
  try {
    const repVitec = yield getHelpTransVitec(action.payload);
    if (repVitec) {
      if (repVitec.data) {
        const by = new Uint8Array(repVitec.data);
        const utf8RespText = Array.from(by)
          .map(function (item) {
            return String.fromCharCode(item);
          })
          .join('');
        yield put(actions.transHelpGetSuccess(utf8RespText));
      }
    }
  } catch (error) {
    yield put(actions.transHelpGetFailed(error));
  }
}
